import React from 'react';
import { Box } from 'grommet';

import type { SHDFooterProps } from './SHDFooter.d';

const SHDFooter: React.FC<SHDFooterProps> = ({
  children,
  fixed = false,
  gap = '0px',
  margin = { top: 'auto' },
}) => {
  const isFixed = {
    position: fixed ? 'fixed' : 'relative',
    bottom: fixed ? '0' : 'auto',
  };

  return (
    <Box
      justify="end"
      flex={true}
      gap={gap}
      margin={margin}
      width="100%"
      {...isFixed}
    >
      {children}
    </Box>
  );
};

export default SHDFooter;
